import { LoginState } from '@treneo/shared/types';

import type { AuthState } from './types';

export const selectLoginState = (state: AuthState) => state.loginState;
export const selectLoginError = (state: AuthState) => state.loginError;
export const selectRegistrationError = (state: AuthState) => state.registrationError;
export const selectResetPasswordError = (state: AuthState) => state.resetPasswordError;
export const selectChangePasswordError = (state: AuthState) => state.changePasswordError;
export const selectForgotPasswordError = (state: AuthState) => state.forgotPasswordError;
export const selectIsChangePasswordSuccess = (state: AuthState) => state.isChangePasswordSuccess;
export const selectIsRegistrationSuccess = (state: AuthState) => state.isRegistrationSuccess;
export const selectIsForgotPasswordSuccess = (state: AuthState) => state.isForgotPasswordSuccess;
export const selectIsLogged = (state: AuthState) => state.loginState === LoginState.LOGGED;
export const selectIsLoginPending = (state: AuthState) => state.loginState === LoginState.PENDING;
export const selectIsNotLogged = (state: AuthState) => state.loginState === LoginState.NOT_LOGGED;
export const selectIsLoginRejected = (state: AuthState) =>
  state.loginState === LoginState.LOGIN_REJECTED;
export const selectHasLoginError = (state: AuthState) => !!state.loginError;
export const selectHasRegistrationError = (state: AuthState) => !!state.registrationError;
export const selectHasResetPasswordError = (state: AuthState) => !!state.resetPasswordError;
export const selectHasChangePasswordError = (state: AuthState) => !!state.changePasswordError;
export const selectCanShowSuccessMessage = (state: AuthState) =>
  state.isChangePasswordSuccess === true || state.isRegistrationSuccess === true;
